module.exports = {
    Unknown: 0,
    USA: 1,
    Canada: 2
}